module.exports = __webpack_public_path__ + "img/Group 2231@2x.88f7e11c.png";